import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import type MedicationDispense from "parog-web/models/medication-dispense";
import type MedicationSpecialty from "parog-web/models/medication-specialty";

export default class MedicationPresentation extends Model {
  @attr("string") declare label: string;
  @hasMany("medication-dispense", {
    async: false,
    inverse: "medicationPresentation"
  })
  declare medicationDispenses: MedicationDispense[];
  @belongsTo("medication-specialty", {
    async: false,
    inverse: "medicationPresentations"
  })
  declare medicationSpecialty: MedicationSpecialty;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "medication-presentation": MedicationPresentation;
  }
}
